import { packageIdentity, templateProductIdentity, } from "./googleTagManagerItemIdentity";
/**
 * A viewed item in the shape the cart events use for an order line of the
 * same thing. A view carries no variant choice for a package, since the
 * visitor picks templates only after opening it.
 */
export default function convertViewedItemToGoogleTagManagerItem(item) {
    if (item.type === "package") {
        const gtmItem = Object.assign(Object.assign({}, packageIdentity(item)), priceFields(item.price));
        if (item.productNames) {
            gtmItem["item_name_in_package"] = item.productNames.join(";");
        }
        return gtmItem;
    }
    return Object.assign(Object.assign({}, templateProductIdentity(item.product, item.template)), priceFields(item.price));
}
function priceFields(price) {
    return {
        price: price.toFixed(2),
        // As for order lines: discount is reserved for rebate codes.
        discount: "0.00",
        quantity: 1,
    };
}
